import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import EdgesensorHighRoundedIcon from "@mui/icons-material/EdgesensorHighRounded";
import ViewQuiltRoundedIcon from "@mui/icons-material/ViewQuiltRounded";
import { NEWS_URL } from "../constants";

const items = [
  {
    icon: <ViewQuiltRoundedIcon />,
    icon: <ViewQuiltRoundedIcon />,
  },
  {
    icon: <EdgesensorHighRoundedIcon />,
  },
];

export default function Features() {
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [news, setNews] = useState([]);
  const navigate = useNavigate();

  const handlePricing = () => {
    navigate(`/pricing`);
  };

  const fetchNewsData = async () => {
    try {
      const today = new Date().toISOString().split("T")[0];
      const response = await fetch(`${NEWS_URL}${today}`);
      if (!response.ok) {
        throw new Error("Failed to fetch news data");
      }
      const data = await response.json();
      //set news data to only recent 10 if lenth is greater than 10 otherwise set all data
      if (data.length > 10) {
        setNews(data.slice(0, 10));
      } else {
        setNews(data);
      }
    } catch (error) {
      console.error("Error fetching news data:", error);
    }
  };

  useEffect(() => {
    fetchNewsData();
  }, []);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };
  const selectedFeature = items[selectedItemIndex];

  return (
    <Container id="features" sx={{ pt:4, pb:8 }}>
      <Typography textAlign="center" pb={4} variant="h2" component="h2" >Features</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            useFlexGap
            sx={{
              width: "100%",
              height: "100%",
              // display: { xs: "none", sm: "flex" },
            }}
          >
            <Grid container spacing={2} textAlign="center">
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <h3>TRACKED PORTFOLIO</h3>
                  <h2>625</h2>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <h3>ALERTS GENERATED</h3>
                  <h2>6969</h2>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <h3>UNIQUE ALERTS COUNTS</h3>
                  <h2>1500</h2>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  {/* Content for the fourth nested card */}
                  <h3>COMPANIES TRACKED</h3>
                  <h2>1.8 Million</h2>
                </Card>
              </Grid>
            </Grid>

            <Card
              variant="outlined"
              sx={{
                height: "100%",
                width: "100%",
                display: { xs: "none", sm: "block" },
              }}
            >
              <Box
                sx={{
                  m: "auto",
                  width: "100%",
                  maxHeight: 500,
                  overflowY: "auto",
                  padding: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Latest News (To Be Replaced)
                </Typography>
                <ul>
                  {news.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        marginBottom: "1rem",
                        filter: index >= 5 ? "blur(2px)" : "none",
                        pointerEvents: index >= 5 ? "none" : "auto",
                        userSelect: index >= 5 ? "none" : "auto",
                      }}
                    >
                      <Typography variant="h6">
                        {index < 5 ? (
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#808080" }}
                          >
                            {item.heading}
                          </a>
                        ) : (
                          <span style={{ color: "#808080" }}>
                            {item.heading}
                          </span>
                        )}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {new Date(item.newsDate).toLocaleString("en-IN", {
                          timeZone: "Asia/Kolkata",
                        })}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Box>
              {news.length > 5 && (
                <Box sx={{ textAlign: "center", padding: 2 }}>
                  <Typography variant="body1">
                    To check all the news, check our prices.
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={handlePricing}
                    color="primary"
                    sx={{ mt: 2 }}
                  >
                    Check Prices
                  </Button>
                </Box>
              )}
            </Card>
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Card variant="outlined" sx={{ 
            height: "100%", 
            width: "100%",
            position: "relative",
            }}
          >
            <Box
              sx={{
                m: "auto",
                width: "100%",
                // maxHeight: 500,
                padding: 2,
              }}
            >
              <Typography variant="h4" gutterBottom>
                Latest News
              </Typography>
              <ul>
                {news.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "1rem",
                      filter: index >= 5 ? "blur(2px)" : "none",
                      pointerEvents: index >= 5 ? "none" : "auto",
                      userSelect: index >= 5 ? "none" : "auto",
                    }}
                  >
                    <Typography variant="h6">
                      {index < 5 ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#808080" }}
                        >
                          {item.heading}
                        </a>
                      ) : (
                        <span style={{ color: "#808080" }}>{item.heading}</span>
                      )}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {new Date(item.newsDate).toLocaleString("en-IN", {
                        timeZone: "Asia/Kolkata",
                      })}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Box>
            {news.length > 0 && (
              <Box sx={{ 
                  position: "absolute",
                  left: "50%",
                  // top: "75%",
                  transform: "translate(-50%, -50%)",
                  bottom: "10px",
                  textAlign: "center",
                  padding: 2 
                }}
              >
                <Typography variant="body1">
                  To check all the news, check our prices.
                </Typography>
                <Button
                  variant="contained"
                  onClick={handlePricing}
                  color="primary"
                  sx={{ mt: 2 }}
                >
                  Check Prices
                </Button>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
